import React, { Component } from 'react';

const PageItem = ({ content, handleOnClick, index, activePage }) => {
  return (
    <a
      key={`pagination-${index}`}
      value={index}
      className={`item${content === activePage ? ' active' : ''}`}
      onClick={e => handleOnClick(e.target.getAttribute('value'))}
    >
      {content}
    </a>
  );
};

export class Pagination extends Component {
  createEllipsisItem = pageNumber => ({
    active: false,
    type: 'ellipsisItem',
    value: pageNumber
  });

  createFirstPage = () => (
    <PageItem
      key={`page-first`}
      handleOnClick={this.props.onPageChange}
      index={1}
      activePage={this.props.activePage}
      content="«"
    />
  );

  createPrevItem = () => {
    let index = Math.max(1, this.props.activePage - 1);
    return (
      <PageItem
        key={`page-prev`}
        handleOnClick={this.props.onPageChange}
        index={index}
        activePage={this.props.activePage}
        content="⟨"
      />
    );
  };

  createNextItem = () => {
    let index = Math.min(this.props.activePage + 1, this.props.totalPages);
    return (
      <PageItem
        key={`page-next`}
        handleOnClick={this.props.onPageChange}
        index={index}
        activePage={this.props.activePage}
        content="⟩"
      />
    );
  };

  createLastItem = () => (
    <PageItem
      key={`page-last`}
      handleOnClick={this.props.onPageChange}
      index={this.props.totalPages}
      activePage={this.props.activePage}
      content="»"
    />
  );

  createPagination = () => {
    let { activePage, totalPages } = this.props;
    let buttons = [this.createFirstPage(), this.createPrevItem()];
    let minus = 0;
    if (totalPages > 0) {
      minus = activePage % 5 === 0 ? 4 : activePage % 5;
    }
    for (
      let i = Math.max(activePage - minus, 1), counter = 0;
      i < totalPages && counter < 5;
      i++
    ) {
      let setPage = i; //activePage > 2 ? i - 2 : i;
      buttons.push(
        <PageItem
          key={`page-${setPage}`}
          handleOnClick={this.props.onPageChange}
          index={setPage}
          activePage={this.props.activePage}
          content={setPage}
        />
      );
      counter++;
    }

    buttons.push(this.createNextItem(), this.createLastItem());
    return buttons;
  };

  render() {
    if (this.props.totalPages <= 1) return '';

    return (
      <div>
        <div
          aria-label="Pagination Navigation"
          role="navigation"
          className="ui pagination menu"
        >
          {this.createPagination()}
          {/* {Array(this.props.totalPages)
            .fill("")
            .map((e, i) => (
              <PageItem
                handleOnClick={this.props.onPageChange}
                index={i + 1}
                activePage={this.props.activePage}
                content={i + 1}
              />
            ))} */}
        </div>

        {/* prettier-ignore */}
        {/* <div aria-label="Pagination Navigation" role="navigation" className="ui pagination menu">
        <a aria-current="false" aria-disabled="false" tabindex="0" value="1" aria-label="First item" type="firstItem" className="item">«</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="4" aria-label="Previous item" type="prevItem" className="item">⟨</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="1" type="pageItem" className="item">1</a>
        <a aria-current="false" aria-disabled="true" tabindex="-1" value="3" type="ellipsisItem" className="item">...</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="4" type="pageItem" className="item">4</a>
        <a aria-current="true" aria-disabled="false" tabindex="0" value="5" type="pageItem" className="active item">5</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="6" type="pageItem" className="item">6</a>
        <a aria-current="false" aria-disabled="true" tabindex="-1" value="7" type="ellipsisItem" className="item">...</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="10" type="pageItem" className="item">10</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="6" aria-label="Next item" type="nextItem" className="item">⟩</a>
        <a aria-current="false" aria-disabled="false" tabindex="0" value="10" aria-label="Last item" type="lastItem" className="item">»</a> */}
        {/* </div> */}
      </div>
    );
  }
}

export default Pagination;
